import React from 'react'
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import { Button } from '@mui/material';
import { useRef } from 'react';



const Chatform = ({ onSend }) => {

  const inputRef = useRef();

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const userMessage = inputRef.current.value.trim();
    if (!userMessage) return;

    inputRef.current.value = "";

    onSend(userMessage);
  };



  return (
    <form action="#" className='chat-form' onSubmit={handleFormSubmit}>
      <input
        ref={inputRef}
        type="text"
        placeholder='Message....'
        className="message-input"
        required
        disabled
      />
      <Button variant='contained'>
        <KeyboardArrowUpRoundedIcon />
      </Button>
    </form>
  )
}

export default Chatform

